import { render, staticRenderFns } from "./PayRangeDetailView.vue?vue&type=template&id=0dd45e9d&scoped=true"
import script from "./PayRangeDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeDetailView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeDetailView.vue?vue&type=style&index=0&id=0dd45e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd45e9d",
  null
  
)

export default component.exports